/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/*  
    Product Accordion module. 
    This module reloads product tabs when user makes selections.
*/

define('modules/Product/ProductAccordion',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var productLandingPageUrl;

    function initializeProductTabs() {
        $("#product-accordion .panel").find(".panel-heading").each(function () {
            $(this).contents().clone().appendTo("#product-accordion-tabs");
        });
        $("#product-accordion-tabs").find(".panel-title").each(function () {
            $(this).wrap('<li/>');
        });
        $("#product-accordion-tabs li:first").find("a").addClass("tab-active");
        $("#product-accordion-tabs li a").each(function () {
            $(this).on('click', function () {
                $("#product-accordion-tabs li a").removeClass("tab-active");
                $(this).addClass("tab-active");
                var productAccordionTabs = $("#product-accordion .panels-wrap .panel a[aria-expanded='true']");
                var productAccordionTabsActive = $("#product-accordion .panels-wrap .panel.panel-open");
                productAccordionTabs.parent().parent().parent().addClass('panel-open');
                if (productAccordionTabs.parent().parent().parent().hasClass('panel-open')) {
                    productAccordionTabsActive.removeClass('panel-open');
                }
                else {
                    $('#product-accordion .panels-wrap .panel.panel-open').removeClass('panel-open');
                    productAccordionTabs.parent().parent().parent().addClass('panel-open');
                }
                $("#product-accordion .panels-wrap .panel").not(".panel-open").find(".panel-title a").attr({ 'class': 'collapsed', 'aria-expanded': 'false' });
                $("#product-accordion .panels-wrap .panel").not(".panel-open").find(".panel-collapse").attr({ 'class': 'panel-collapse collapse', 'aria-expanded': 'false' });
            });
        });	
    }

    function reloadProductAccordion(viewModel) {
        Roc.Data.getAsync({
            url: productLandingPageUrl,
            data: { id: viewModel.id },
            callback: function (data) {
                if (data && data.Success === true) {
                    var content = $(data.html).filter('.accordionModule').html();

                    $('.accordionModule').html(content);
                    initializeProductTabs();
                }
            }
        });
    }

    function init(landingPageUrl) {
        productLandingPageUrl = landingPageUrl;
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductAccordion);

    }

    var ProductAccordion = {
        init: init
    }

    Roc.Logger.debug('ProductAccordion.js Loaded:', ProductAccordion);

    return ProductAccordion;
});
